var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi && _vm.ready
    ? _c("app-sale-type-select", {
        attrs: {
          "use-purchase-and-sale": "",
          "use-id": "",
          fancy: "",
          value: _vm.singleValue,
          label: _vm.label,
        },
        on: {
          input: function ($event) {
            return _vm.setValue($event)
          },
        },
      })
    : _vm.ready
    ? _c("app-sale-type-multi-select", {
        attrs: {
          fancy: "",
          value: _vm.inputValues,
          label: _vm.label,
          "use-purchase-and-sale": "",
          "use-id": "",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }